import type { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export default function PageContainer({ children, className = "" }: PageContainerProps) {
  return (
    <div className={`w-full max-w-[1280px] mx-auto px-4 md:px-6 ${className}`}>
      {children}
    </div>
  );
}